const genericError = 'generic_error';
const disagreeDod = 'JP31';
export const jpCodes = {
  genericError,
  disagreeDod,
};
